import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "email-wrapper" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = {
  title: "Email",
  class: "fa-layers fa-fw"
}
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "phone-wrapper" }
const _hoisted_9 = { class: "left" }
const _hoisted_10 = {
  title: "Phone",
  class: "fa-layers fa-fw"
}
const _hoisted_11 = { class: "right" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!
  const _component_modal_small_refi = _resolveComponent("modal-small-refi")!

  return (_openBlock(), _createBlock(_component_modal_small_refi, {
    class: "support-modal",
    closeBtn: true,
    onClose: _ctx.close
  }, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode("Contact Us", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("p", null, "If you need to contact our concierge team, they are available by:", -1)),
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_component_font_awesome_layers, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-regular fa-circle",
                      class: "circle",
                      size: "10x"
                    }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-envelope",
                      class: "icon",
                      transform: "shrink-7"
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "row subheader" }, "Email", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", {
                  class: "email-link",
                  href: `mailto:${_ctx.emailAddress}`
                }, _toDisplayString(_ctx.emailAddress), 9, _hoisted_7)
              ])
            ])
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_font_awesome_layers, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-regular fa-circle",
                      class: "circle",
                      size: "10x"
                    }),
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-phone",
                      class: "icon",
                      transform: "shrink-7"
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "row subheader" }, "Phone", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", {
                    class: "phone-link",
                    href: `tel:+${_ctx.hrefTFN}`
                  }, _toDisplayString(_ctx.tollFreeNumber), 9, _hoisted_14)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("span", null, "Agents are available by phone 24 hours a day, 7 days a week.")
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}